/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Act_HearInputs */

const en_of_landing_act_hear = /** @type {(inputs: Of_Landing_Act_HearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hear nearby conversations`)
};

const id_of_landing_act_hear = /** @type {(inputs: Of_Landing_Act_HearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dengar obrolan di sekitar`)
};

/**
* | output |
* | --- |
* | "Hear nearby conversations" |
*
* @param {Of_Landing_Act_HearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_act_hear = /** @type {((inputs?: Of_Landing_Act_HearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Act_HearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_act_hear(inputs)
	return en_of_landing_act_hear(inputs)
});